import { apiSlice } from '../apiSlice';
import { Alley } from '../schemas/alley';
import { DeleteResponse } from '../schemas/apiResponse';
import { PaginatedArgs, PaginatedResponse } from '../schemas/pagination';
import { filterParamsAdapter } from '../utils/filterParamsAdapter';
import { providesList } from '../utils/providesList';

type AlleyFilterParams = {
  id__in?: string[];
  collection_id__in?: string[];
  file_name__in?: string[];
  file_name__like?: string;
};

const ALLEYS_PATH = '/alleys';

const alleyEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllAlleys: builder.query<
      Alley[],
      (AlleyFilterParams & PaginatedArgs) | void
    >({
      query: (params) => ({
        url: ALLEYS_PATH,
        params: params ? filterParamsAdapter(params) : undefined,
      }),
      providesTags: (result) => providesList(result, 'Alley'),
    }),

    getAlleysForCollection: builder.query<PaginatedResponse<Alley>, string>({
      query: (collectionId) => ({
        url: ALLEYS_PATH,
        params: filterParamsAdapter({ collection_id__in: [collectionId] }),
      }),
      providesTags: (result) => providesList(result?.items || [], 'Alley'),
    }),

    getAlley: builder.query<Alley, string>({
      query: (id) => `${ALLEYS_PATH}/${id}`,
      providesTags: (result, error, id) => [{ type: 'Alley', id }],
    }),

    deleteAlley: builder.mutation<DeleteResponse, string>({
      query(id) {
        return {
          url: `${ALLEYS_PATH}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, id) => [{ type: 'Alley', id }],
    }),
  }),
});

export const {
  useGetAllAlleysQuery,
  useGetAlleysForCollectionQuery,
  useGetAlleyQuery,
  useDeleteAlleyMutation,
} = alleyEndpoints;
